import React from 'react';

import { IBupNonUse } from '../selectors';

import styles from './styles.module.scss';

const getReasonsGroupKey = (key: number) => `reasons-group-${key}`;
const getReasonKey = (key: number) => `reason-${key}`;

const BuprenorphineNonUse = ({ bupNonUses }: { bupNonUses: IBupNonUse[] }) => (
  <div data-testid="bup-non-use-section">
    <h1 className={styles.header}>
      <span className={styles['bup-nonuse']} />
      <span className={styles.label}>Buprenorphine Non-Use</span>
    </h1>
    <table className={styles['outer-table']}>
      <tbody>
        <tr className={styles['header-row']}>
          <td>Date</td>
          <td>Reasons</td>
          <td />
          <td />
        </tr>
        {bupNonUses.map((item) => (
          <tr
            data-testid="bup-non-use-row"
            className={styles['reasons-row']}
            key={`data-${item.date}`}
          >
            <td className={styles.date}>{item.date}</td>
            <td className={styles['reason-group']}>
              <table className={styles['inner-table']}>
                <tbody>
                  {item.reasons.map((reasons, key1) => (
                    <tr key={getReasonsGroupKey(key1)}>
                      {reasons.map((reason, key2) => (
                        <td className={styles.reason} key={getReasonKey(key2)}>
                          {reason}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default BuprenorphineNonUse;
